import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Observable, of } from 'rxjs'
import { catchError, map, startWith } from 'rxjs/operators'
import { CallerService } from '../../services/caller.service'
import { AccommodationType, SaleType } from '../../ngrx-store/app.state'

/** `undefined` while checking; `null` if the check failed (then it's the plain warning). */
type ConversationCount = number | null | undefined

@Component({
  selector: 'app-delete-post',
  templateUrl: './delete-post.component.html',
  styleUrls: ['./delete-post.component.css'],
})

// @todo: rename to ConfirmDeletePostComponent
export class DeletePostComponent implements OnInit {
  /** How many people you're chatting with about the post - they get a warning of their own. */
  conversations$: Observable<ConversationCount> = of(null)

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { sale?: SaleType, accommodation?: AccommodationType },
    public dialogRef: MatDialogRef<DeletePostComponent>,
    private callerService: CallerService,
  ) {}

  ngOnInit(): void {
    const count$ = this.data.sale?.id
      ? this.callerService.getSaleConversationCount(this.data.sale.id)
      : this.data.accommodation?.id
        ? this.callerService.getAccommodationConversationCount(this.data.accommodation.id)
        : null
    if (count$) {
      this.conversations$ = count$.pipe(
        map((res): ConversationCount => res.body?.data.conversations ?? null),
        catchError(() => of(null)),
        startWith(undefined),
      )
    }
  }

  /** What the warning calls it. */
  get thing(): string {
    return this.data.sale ? 'item' : 'place'
  }

  get title(): string {
    if (this.data.sale?.item_name) return `Delete ${this.data.sale.item_name}?`
    return this.data.accommodation ? `Delete this ${this.data.accommodation.accommodation_type || 'place'}?` : 'Delete this post?'
  }

  deletePost() {
    this.dialogRef.close('delete')
  }
}
